import { t } from "i18next";
import { toast } from "react-toastify";
import { Types } from "shared-lib";
  export const getStatusText = (isScheduledRide?: boolean, status?: Types.RideStatusEnum) => {
    if (isScheduledRide) {
      return t("Agendada");
    }

    switch (status) {
      case Types.RideStatusEnum.PENDING_ACCEPT:
        return t("Pedido Pendente");
      case Types.RideStatusEnum.PENDING_ARRIVAL:
        return t("Aguardando chegada");
      case Types.RideStatusEnum.RIDE_STARTED:
        return t("Viagem iniciada");
      case Types.RideStatusEnum.PENDING_OTP:
        return t("Pendente de OTP");
      case Types.RideStatusEnum.PENDING_PAYMENT:
        return t("Pagamento pendente");
      case Types.RideStatusEnum.WAIT_FOR_DRIVER:
        return t("Aguardando motorista");
      case Types.RideStatusEnum.PAYMENT_FAILED:
        return t("Pagamento falhou");
      case Types.RideStatusEnum.CANCELLED:
        return t("Cancelada");
      case Types.RideStatusEnum.COMPLETED:
        return t("Completa");
      default:
        return t("Status desconhecido");
    }
  };
  export const successToast = (message: string) => {
      toast.success(`${message}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { borderRadius: "15px" },
      });
    };
  
    export const errorToast = (message: string) => {
      toast.error(`${message}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { borderRadius: "15px" },
      });
    };
  